import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import Progress from "../../general/include/Progress";
import AppContext from "../../../contexts/AppContext";
import { register, getUserData } from "../../../services/user";
import RegisterTab from "./RegisterTab";
import "./RegisterTab.css"
import Footer from "../../general/include/Footer";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
export class WriterRegister extends Component {
    // static propTypes = {
    //     match: PropTypes.object.isRequired,
    //     location: PropTypes.object.isRequired,
    //     history: PropTypes.object.isRequired
    // };
	state = {
      activeTab: '1',
      header1:true,
    };
	
	// constructor(props) {
    //     super(props);
    //     this.state = {         
    //         item: {
    //             type: "writer",
    //             email: "",
    //             hasEmail: false,
    //             hasName: false,
    //             externalUserId: "",
    //             first_name: "",
    //             last_name: ""

    //         },
    //         errors: {},
    //     };
    // }
	
	// toggleWregister = () =>{
	// 	this.props.toggleWregister();
	// }
	
    // onChange = field => {
    //     let temp = this.state.item;
    //     temp[field.target.name] = field.target.value;

    //     let error = this.state.errors;
    //     error[field.target.name] = null;

    //     this.setState({ item: temp, errors: error });
    // };
    // submitRegister = e => {
    //     e.preventDefault();
	// 	this.setState({loading: true});
    //     register(this.state.item)
    //         .then(res => {
    //             console.log(res);
	// 			this.setState({loading: false});
    //             localStorage.setItem("auth_token", res.meta.token);
    //             localStorage.setItem("alerts", null);
    //             localStorage.setItem("welcome", null);
    //             localStorage.setItem("user_email",res.data.email);
    //             localStorage.setItem("user_steps", "writing-jobs");
    //             localStorage.setItem("user", JSON.stringify(res.data));
    //             if (res.meta.token) {
    //                 //window.location = "/pw/" + res.data.url;
    //                 window.location = "/process/writingjobs";
    //             }
    //         })
    //         .catch(error => {
    //             console.log(error);
	// 			this.setState({loading: false});
    //             switch (error.response.status) {
    //                 case 422:
    //                     this.setState({
    //                         errors: error.response.data.error
    //                     });
    //                     break;
    //                 default:
    //                     this.context.state.handelError(error);
    //                     break;
    //             }
    //         });
    // };

    constructor(props) {
        super(props);
        this.handleCallback = this.handleCallback.bind(this);
        const nextRoute = new URLSearchParams(window.location.search); 
        if(nextRoute.get('next') == 'post-job' && this.state.activeTab == '1'){
            this.state.header1 = false;
        }else{
            // this.state.header1 = true;
        }
    }

    componentDidMount() {
        this.context.state.updateMetaData('register');

    } 

        // this.context.state.updateMetaData('register');

    //     let locationPath = this.props.location.pathname.split("-i-");
    //     // this.nameInput.focus();

    //     if (locationPath.length == 2) {
    //         let externalUserId = locationPath[1];

    //         let temp = this.state.item;
    //         temp['externalUserId'] = locationPath[1];
    //         this.setState({ item: temp });

    //         let data = { 'externalUser': this.state.item.externalUserId };

    //         getUserData(data)
    //             .then(res => {
    //                 let temp = this.state.item;
    //                 temp['first_name'] = res.data.first_name;
    //                 temp['last_name'] = res.data.last_name;
    //                 temp['hasName'] = true;
    //                 if (res.data.email !== null) {
    //                     temp['email'] = res.data.email;
    //                     temp['hasEmail'] = true;
    //                 }
    //                 this.setState({ item: temp });
    //             })
    //             .catch(error => {
    //                 this.setState({ loading: false });
    //                 switch (error.response.status) {
    //                     case 422:
    //                         this.setState({
    //                             errors: error.response.data.error
    //                         });
    //                         break;
    //                     default:
    //                         this.context.state.handelError(error);
    //                         break;
    //                 }
    //             });
    //     }
       
    // }
    handleCallback = (childData) =>{
     this.state.activeTab = childData;
    const nextRoute = new URLSearchParams(window.location.search); 
     if(nextRoute.get('next') == 'post-job' && childData == '1'){
        this.state.header1 = false;
     }else{
        this.state.header1 = true;
     }
    //  alert( this.state.header1);
     this.forceUpdate();
    }
    // componentDidUpdate(){}
    render() {
        //const { match, location, history } = this.props;
		return (
            <Fragment>
			    <Header></Header>
				<section className="sub-header py-3">
				    <div className="container">
					    <p className="text-white text-center"><span className="font-weight-bold">ProWriter:</span> The #1 Source For Professional Freelance Writers</p>
					</div>
				</section>
			    <section className="writer-form-container py-5">
				    <div className="container">
					    <div className="sub-container p-md-4 p-sm-4 p-3 mx-auto">
				            <div className="px-sm-4">    
                            {this.state.header1 == true ?
								<h1 className="font-weight-bold text-center m-0" id="model-title">
                                    <b>Create Your Free Account</b>
                                </h1>:
                                <div className="job-post-account font-weight-bold text-center m-0">
                                    <h3>Before Posting a Job</h3>
                                    <h1>Create a Free Employer Account</h1>
                                </div>
                                }
						        {/* <h3 className="text-center mb-3">
						            <b>Start your FREE 14 Day Trial Now!</b>

						        </h3>
							    <Progress ariavalue="25" content="Step 1 of 3...." width='25%'></Progress>
								<p className="text-center pt-2 pb-3 border-top">No long-term contracts. Downgrade or cancel your account anytime with a single click from your dashboard...</p> */}
                                <RegisterTab parentCallback = {this.handleCallback} localtionPath={this.props.location.pathname.split("-i-")}/>
							</div>
				            {/* <form className="px-sm-4" onSubmit={this.submitRegister} method="POST">
                                <div className="form-group mb-4 row">
                                    <div className="col-12 col-md-6 mt-4">
                                        <input
                                            ref={input => {
                                                this.nameInput = input;
                                            }}
                                            id="first_name"
                                            type="text"
											placeholder="Enter Your First Name..."
                                            className={
                                                this.state.errors.first_name
                                                    ? "is-invalid form-control  form-control-large"
                                                    : " form-control  form-control-large"
                                            }
                                            name="first_name"
                                            autoComplete="off"
                                            onChange={this.onChange}
                                            value={this.state.item.first_name}
                                            disabled={this.state.item.hasName}
                                        />
                                        {this.state.errors.first_name ? (
                                            <div className="invalid-feedback">
                                                {
                                                    this.state.errors
                                                        .first_name
                                                }
                                            </div>
                                        ) : null}
                                    </div>
									<div className="col-12 col-md-6 mt-4">
                                        <input
                                            id="last_name"
                                            type="text"
											placeholder="Enter Your Last Name..."
                                            className={
                                                this.state.errors.last_name
                                                    ? "is-invalid form-control  form-control-large"
                                                    : " form-control  form-control-large"
                                            }
                                            name="last_name"
                                            autoComplete="off"
                                            onChange={this.onChange}
                                            value={this.state.item.last_name}
                                            disabled={this.state.item.hasName}
                                        />
                                        {this.state.errors.last_name ? (
                                            <div className="invalid-feedback">
                                                {
                                                    this.state.errors
                                                        .last_name
                                                }
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="form-group mb-4">
                                    <input
                                        onChange={this.onChange}
                                        type="text"
										placeholder="Enter Your Email Address..."
                                        className={
                                            this.state.errors.email
                                                ? "is-invalid form-control  form-control-large"
                                                : " form-control  form-control-large"
                                        }
                                        name="email"
                                        autoComplete="off"
                                        id="email"
                                        value={this.state.item.email}
                                        disabled={this.state.item.hasEmail}
                                    />
                                    {this.state.errors.email ? (
                                        <div className="invalid-feedback">
                                            {this.state.errors.email}
                                        </div>
                                    ) : null}
                                </div>
                                <div className="form-group mb-4">
                                    <input
                                        onChange={this.onChange}
                                        type="password"
										placeholder="Create Your Password..."
                                        name="password"
                                        id="password"
                                        className={
                                            this.state.errors.password
                                                ? "is-invalid form-control  form-control-large"
                                                : " form-control  form-control-large"
                                        }
                                    />
                                    {this.state.errors.password ? (
                                        <div className="invalid-feedback">
                                            {this.state.errors.password}
                                        </div>
                                    ) : null}
                                </div>
                                <button disabled={this.state.loading} className="bold btn form-control-large btn-lg btn-block btn-primary mt-5 mb-3 mx-auto py-3">
								    <i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : ``}></i> {this.state.loading ? `Submitting...` : `Start Applying To Writing Jobs!`}
								</button>
								<small className="text-center text-grey d-block"><i className="fa fa-lock mr-2"></i>By providing us with your information you are consenting to the collection and use of your information in accordance with our <a href="https://www.iubenda.com/privacy-policy/72278847">Privacy Policy.</a></small>
                            </form> */}
						</div>
                        <div className="testimonial-container mx-auto px-3 mt-5">
						    <div className="row align-items-center">
							    <div className="col-sm-4 px-4">
								    <img className="w-auto img-fluid" src="/images/JessicaLakritz.png" alt="image" width="100" height="100"/>
								</div>
								<div className="col-sm-8 mt-md-0 mt-3">
								    <p className="text-secondary text-md-left text-center">My skills as a writer have significantly improved thanks to ProWriter. It’s helped me to write clearly and concisely about pretty much anything. Plus, I’ve also learned SEO skills which have helped me to get my dream clients!<br/><span className="font-weight-bold">Jessica Lakritz</span></p>
								</div>
							</div>
						</div>
					</div>
				</section>	
                <Footer/>
            </Fragment>
        );
    }
}

WriterRegister.contextType = AppContext;
export default WriterRegister;



// WEBPACK FOOTER //
// ./src/components/auth/register/WriterRegister.js